import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=0fcc0109&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=ts"
export * from "./UserSelect.vue?vue&type=script&lang=ts"
import style0 from "./UserSelect.vue?vue&type=style&index=0&id=0fcc0109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc0109",
  null
  
)

export default component.exports